import { render, staticRenderFns } from "./ProductDetailPP.vue?vue&type=template&id=5dfcf830&scoped=true&"
import script from "./ProductDetailPP.vue?vue&type=script&lang=js&"
export * from "./ProductDetailPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfcf830",
  null
  
)

export default component.exports